import { Suspense, createElement } from 'react';
import type { SearchResultAction } from '@reflex/plugin-api';
import type { ResolvedSearchProvider } from '@/lib/plugin-registry';

interface CommandPaletteSearchSectionProps {
  provider: ResolvedSearchProvider;
  query: string;
  limit?: number;
  onSelect: (action: SearchResultAction) => void;
}

/**
 * Renders a single plugin-contributed search provider inside the command
 * palette. The provider component is lazy-loaded and receives the current
 * trimmed `query` plus an `onSelect` callback that dispatches the resulting
 * `SearchResultAction` back to the palette for routing.
 */
export function CommandPaletteSearchSection({
  provider,
  query,
  limit = 5,
  onSelect,
}: CommandPaletteSearchSectionProps) {
  return (
    <Suspense fallback={null}>
      {createElement(provider.component, {
        query,
        onSelect,
        limit,
        groupHeading: provider.label,
      })}
    </Suspense>
  );
}
